import loadable from '@loadable/component';

export const MyAccountDropdownContainerLoadable = loadable(
  () => import('./MyAccountDropdownContainer'),
  { resolveComponent: (module) => module.MyAccountDropdownContainer },
);
